import { createSlice } from '@reduxjs/toolkit';
import { auditLogsApi } from '@store/rtk/auditLogs';
import { TableData } from '@uikit/Tables/types';
import { formatFieldTitle } from '@utils/inputTitles';
import { formatUTCToLocal } from '@src/utils';
import { TABLE_COLUMNS } from '@uikit/Tables/columns';

type AuditLogsSliceType = {
  auditLogsData: TableData;
  recordViewData: TableData;
};

const { auditLogsColumns, recordViewColumns } = TABLE_COLUMNS;

const initialState: AuditLogsSliceType = {
  auditLogsData: {
    columns: auditLogsColumns,
    rows: [],
    size: 5,
  },
  recordViewData: {
    columns: recordViewColumns,
    rows: [],
    size: 5,
  },
};

export const auditLogsSlice = createSlice({
  name: 'auditLogs',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      auditLogsApi.endpoints.getLogs.matchFulfilled,
      (state, { payload }) => {
        if (payload.content && Array.isArray(payload.content)) {
          state.auditLogsData = {
            ...state.auditLogsData,
            ...payload,
            rows: [
              ...payload.content.map((el) => ({
                ...el,
                field: formatFieldTitle(el.field ?? ''),
                actionTime: formatUTCToLocal(el.actionTime),
              })),
            ],
            ...payload,
            requestTablePageChange: auditLogsApi.endpoints.getLogs,
          };
        }
      }
    );
    builder.addMatcher(
      auditLogsApi.endpoints.getRecordViewHistory.matchFulfilled,
      (state, { payload }) => {
        if (payload.content && Array.isArray(payload.content)) {
          state.recordViewData = {
            ...state.recordViewData,
            ...payload,
            rows: [
              ...payload.content.map((el) => ({
                ...el,
                timestamp: formatUTCToLocal(el.timestamp),
              })),
            ],
            requestTablePageChange: auditLogsApi.endpoints.getRecordViewHistory,
          };
        }
      }
    );
  },
});

export const selectAuditLogs = (state: { auditLogs: AuditLogsSliceType }) =>
  state.auditLogs;
export const auditLogsReducer = auditLogsSlice.reducer;
